/* eslint-disable no-cond-assign */
/* eslint-disable no-param-reassign */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-restricted-globals */
import { useState, useEffect } from 'preact/hooks'

const hidden = `--is-hidden`
const visible = `--is-visible`

export function useSize() {
	const [width, setWidth] = useState(window.innerWidth)

	function handleWindowSizeChange() {
		setWidth(window.innerWidth)
	}

	useEffect(() => {
		window.addEventListener('resize', handleWindowSizeChange)

		return () => window.removeEventListener('resize', handleWindowSizeChange)
	}, [])

	const isMobile = width < 768
	const isTablet = width < 1024 && width >= 768
	const isDesktop = width > 1024

	return { isMobile, isTablet, isDesktop }
}

/**
 * Gets a *computed* CSS value of a certain element property
 * @param {*} element - defaults to window if not passed
 * @param {*} property - CSS property to get value of
 * @returns 
 */
export function getComputedStyleProp(element, property) {
	if (element) {
		const cssObj = window.getComputedStyle(element, null)

		if (cssObj) return cssObj.getPropertyValue(property) || null
	}

	if (!element) {
		const b = document.querySelector('body')
		const cssObj = window.getComputedStyle(b, null)

		if (cssObj) return cssObj.getPropertyValue(property) || null
	}

	return null
}

/**
 * Returns a CSS document from document matching entered variable name
 */
export function getCssVar(cssVarName) {
	const doc = getComputedStyle(document.documentElement)

	if (!doc || !cssVarName) {
		return 'no-value'
	}

	if (doc) {
		return doc.getPropertyValue(cssVarName)
	}
}

export function setCssVar(key, value) {
	const doc = getComputedStyle(document.documentElement)

	if (!doc || !(key && value)) {
		doc.setProperty(key, value)
	}
}

export function moveElement(elementSelector, targetSelector) {
	var element = document.querySelector(elementSelector)
	if (!element) return

	const targetElement = document.querySelector(targetSelector)
	if (!targetElement) return

	targetElement.appendChild(element)
}

export function findAncestor(el, sel) {
	while ((el = el.parentElement) && !(el.matches || el.matchesSelector).call(el, sel));
	return el
}

export const isHidden = element => {
	element.classList.contains(hidden)
}

export const isVisible = (element, className) => {
	if (className != null) {
		return element.classList.contains(className)
	}

	return element.classList.contains(visible)
}

/**
 * Creates a FormData object from a valid JavaScript object
 * @param {*} object Any valid object.
 * @returns {FormData} A FormData object.
 */
export const getFormData = object => {
	const formData = new FormData()

	// Get all keys from object and turn into formData
	Object.keys(object).forEach(key => formData.append(key, object[key]))

	// Return form data from object
	return formData
}

export function decode(input) {
    var doc = new DOMParser().parseFromString(input, "text/html");
    return doc.documentElement.textContent;
}

/**
 *  Returns true for a dom-element if it is *entirely* within the device viewport bounds
 *  @param HTMLElement The element
 */
export const isElementInViewport = element => {
	var rect = element.getBoundingClientRect()

	return (
		rect.top >= 0 &&
		rect.left >= 0 &&
		rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
		rect.right <= (window.innerWidth || document.documentElement.clientWidth)
	)
}

/**
 * Retry function after delay
 */
export const retry = async (callback, delay) => {
	if (typeof callback === 'function') {
		setTimeout(callback.call(), delay || 33)
	}
}
